import React, { useContext } from "react";
import "./program-brochure.css";
import { ContextUser } from "src/context/ContextUser";

export function ProgramBrochure() {
  const { merchant } = useContext(ContextUser);
  return (
    <div className="container">
      {/* Page 1 */}
      <div className="card page-spacing">
        <div className="card-content">
          {/* Header */}
          <div className="header">
            <h1>L192</h1>
            <h2>CHINA-BASED SELLERS</h2>
            <h2>ORIENTATION PROGRAM</h2>
          </div>

          {/* Description */}
          <div className="description">
            <p>
              We recognize the unique importance of China-based sellers. Language and cultural barriers limit
              cooperation between China-based sellers and the platform. To solve this problem, we decided to have an
              independent partner based in China. We have trained and certified an independent partner to be our partner
              trainer. The partner plays a key role in onboarding and orientating new sellers so that sellers can
              operate their stores effectively on our platform. The partner also serves as a bridge between sellers and
              the platform to solve any issue. Any new China-based seller must undergo training conducted by our
              independent partner before the platform can approve their store registration. The independent partner will
              charge a fee for their service. Please contact the orientation partner.
            </p>
          </div>

          {/* Contact Section */}
          <div className="contact-grid">
            <div className="contact-item">
              {/* <div className="logo-container">
                <div className="logo-text">Z</div>
              </div>
              <div className="company-name">泽瀚跨境</div> */}
              <div className="log-container">
                <img
                  src="//s9.kh1.co/c2/c26f4027f8198e92fb9d7d6dc2c297f43af04a63.png"
                  alt=""
                  style={{ objectFit: "contain", width: "10rem", height: "auto" }}
                />
              </div>
            </div>
            <div className="contact-item">
              <div className="log-container">
                {/* <div className="qr-text">QR Code</div> */}
                <img
                  src="//s9.kh1.co/13/13741c2027aedd4fbe0b2ad3c7ae75b02bed230e.png"
                  alt=""
                  style={{ objectFit: "contain", width: "10rem", height: "auto" }}
                />
              </div>
            </div>
            <div
              className="contact-item"
              style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}
            >
              <div className="tel-label">Tel</div>
              <div className="tel-number">17038032999</div>
            </div>
          </div>

          {/* Fee Section */}
          <div className="fee-section">
            <div className="fee-label">FEE</div>
            <div className="fee-amount">$399</div>
          </div>

          {/* Training Points */}
          <div className="training-intro">
            <p>
              The agent provides you with valuable information about how to operate your store efficiently. The training
              will cover the following 9 points:
            </p>
          </div>

          <div className="training-grid">
            <div className="training-column">
              <div className="training-item">
                <h3>1. General platform orientation</h3>
              </div>

              <div className="training-item">
                <h3>2. Registration process</h3>
              </div>

              <div className="training-item">
                <h3>3. Products</h3>
                <div className="training-list">
                  <div>Listing/de-listing</div>
                  <div>Product uploading</div>
                  <div>Product video</div>
                  <div>Product pricing</div>
                  <div>Refilling</div>
                  <div>Analysis</div>
                  <div>What to sell</div>
                </div>
              </div>

              <div className="training-item">
                <h3>4. Inventory</h3>
                <div className="training-list">
                  <div>Create shipment</div>
                  <div>Preparing shipments (labeling and packaging)</div>
                  <div>Shipping to L192 warehouse</div>
                  <div>Understanding L192 product shelving</div>
                </div>
              </div>

              <div className="training-item">
                <h3>5. Disbursement</h3>
              </div>
            </div>

            <div className="training-column">
              <div className="training-item">
                <h3>6. Marketing</h3>
                <div className="training-list">
                  <div>Store branding/decoration</div>
                  <div>Promo code</div>
                  <div>Promo combo</div>
                  <div>Joining main events</div>
                  <div>Store promotion</div>
                  <div>Platform marketing tools</div>
                  <div>Omni channel marketing channels linked to the platform</div>
                </div>
              </div>

              <div className="training-item">
                <h3>7. Report</h3>
                <div className="training-list">
                  <div>CTR</div>
                  <div>Sales report</div>
                  <div>Product insights</div>
                </div>
              </div>

              <div className="training-item">
                <h3>8. Customer communication/retention</h3>
                <div className="training-list">
                  <div>Understanding customer communication (chat and more)</div>
                  <div>Understanding customer expectations</div>
                </div>
              </div>

              <div className="training-item">
                <h3>9. Prohibited products</h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Page 2 */}
      <div className="card">
        <div className="card-content content-spacing">
          <div className="text-content">
            <p>
              The fee of $399 includes the partner's effort and time to train sellers best practices and the platform
              registration fee.
            </p>

            <div>
              <p>With the fee, the platform helps launch the store by</p>
              <ol className="numbered-list">
                <li>sending a notification to relevant buyers,</li>
                <li>announcing the profile of the store on all the social media channels, and</li>
                <li>featuring the store at the home screen for 10 days.</li>
              </ol>
              <p className="numbered-list-note">
                * The store must have at least 50 distinct products at the warehouse. And the products pass the quality
                inspection.
              </p>
            </div>

            <p>
              The store gets prioritized and efficient responses as the store works with the platform's independent
              partner.
            </p>

            <div>
              <h3 className="premium-title">*PREMIUM SERVICES</h3>
              <p>The store also has access to premium services which are not available to general members.</p>
            </div>
          </div>

          {/* Premium Services */}
          <div className="premium-services">
            <div className="service-item">
              <div className="service-content">
                <p>
                  <span className="service-bold">Original product photography with beauty talents.</span> China-based
                  sellers use photos from Chinese platforms which are not premium and relevant in Cambodia. Original
                  product photography with local beauty talents makes your products stand out.
                </p>
              </div>
              <div
                className="service-image service-image-gray"
                style={{ width: "12rem", height: "auto", objectFit: "contain", aspectRatio: "auto" }}
              >
                <img src="//s9.kh1.co/2e/2eb291ea8cf845b192ee40d6b8fc54a795f15c58.png" alt="" />
              </div>
            </div>

            <div className="service-item">
              <div className="service-content">
                <p>
                  <span className="service-bold">Exclusive clearance sales campaign.</span> A team will study your
                  products that you request to clear and organize campaigns to clear your products.
                </p>
              </div>
              <div
                className="service-image service-image-orange"
                style={{ width: "12rem", height: "auto", objectFit: "contain", aspectRatio: "auto" }}
              >
                {/* <span className="service-image-text-orange">CLEARANCE SALE</span> */}
                <img src="//s9.kh1.co/61/617da466f182762e367a5b79301c53f1d70d694d.png" alt="" />
              </div>
            </div>

            <div className="service-item">
              <div className="service-content">
                <p>
                  <span className="service-bold">Chat handling.</span> Chatting with buyers increases the buying chance.
                </p>
              </div>
              <div
                className="service-image service-image-blue"
                style={{ width: "12rem", height: "auto", objectFit: "contain", aspectRatio: "auto" }}
              >
                {/* <span className="emoji">💬</span> */}
                <img src="//s9.kh1.co/a8/a85070a73e4e2ac528166f4005f455a800bcfe8b.png" alt="" />
              </div>
            </div>

            <div className="service-item">
              <div className="service-content">
                <p>
                  <span className="service-bold">Customized marketing strategies.</span> Omni channel marketing includes
                  Livestreaming, TikTok, and Facebook. It works best to highlight your entire store or a specific
                  product with high margin.
                </p>
              </div>
              <div
                className="service-image service-image-gray"
                style={{ width: "12rem", height: "auto", objectFit: "contain", aspectRatio: "auto" }}
              >
                {/* <span className="service-image-text">Marketing Team</span> */}
                <img src="//s9.kh1.co/3a/3a9bbdcda3000e18785e100fbc10e7b709183c99.png" alt="" />
              </div>
            </div>

            <div className="service-item">
              <div className="service-content">
                <p>
                  <span className="service-bold">Influencer marketing.</span> It is a powerful marketing strategy.
                </p>
              </div>
              <div
                className="service-image service-image-purple"
                style={{ width: "12rem", height: "auto", objectFit: "contain", aspectRatio: "auto" }}
              >
                {/* <span className="service-image-text-purple">TikTok</span> */}
                <img src="//s9.kh1.co/07/0701174cdf1910920d3f7f309d0c4efd19b05066.png" alt="" />
              </div>
            </div>
          </div>

          {/* Final Note */}
          <div className="final-note">
            <h3>Final note</h3>
            <p>
              E-commerce in Cambodia is at its early stage. Establishing a big online store through L192 platform is a
              long- term investment and commitment. Be the first mover. Stores with more products sell better than small
              stores with a limited number of products. Try to increase the number of products rather than the quantity
              of each product. Refill more often.
            </p>
          </div>

          <div className="final-note">
            <h3>Store Info</h3>
            <p>Store: {merchant.name}</p>
            <p>Email: {merchant.emails}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
